import React from 'react'
import styles from './BoxProject.module.css'
import { HoverState } from '../../../../assets/utils/cursorTypes';
import IconComponent from '../../../IconComponent/IconComponent';
import { FaArrowRight, FaCircle } from 'react-icons/fa';
import { urlFor } from '../../../../assets/lib/sanity.client';
import { useNavigate } from 'react-router-dom';
import { ProjectInterface } from '../../../../assets/lib/types/project';

export type BoxProjectProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    project: ProjectInterface;
}

const BoxProject = (props: BoxProjectProps) => {

    const handleMouseEnter = () => props.setHoverElement('pointer');
    const handleMouseLeave = () => props.setHoverElement('normal');
    const navigate = useNavigate();

    return (
        <div 
            className={styles.box}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={() => navigate(`/project/${props.project._id}`)}
        >
            <div className={styles.box_content}>
                <img src={urlFor(props.project.image).url()}  alt="" />
            </div>
            <div className={styles.box_info}>
                <div className={styles.box_info_header_wrapper}>
                    <div className={styles.box_info_header}>
                        <span className={styles.box_title}>{props.project.title}</span>
                        <span className={styles.box_view_more}>
                            View Project <IconComponent icon={FaArrowRight} size={15} />
                        </span>
                    </div>
                    <div className={styles.box_info_header2}>
                        <span className={styles.box_title}>{props.project.title}</span>
                        <span className={styles.box_view_more}>
                            View Project <IconComponent icon={FaArrowRight} size={15} />
                        </span>
                    </div>
                </div>
                <div className={styles.box_info_tags_wrapper}>
                    <div className={styles.box_info_tags}>
                        {props.project.tags.map((tag, index) => (
                            <div className={styles.box_info_tag} key={index}>
                                <span>{tag}</span>
                                {index + 1 !== props.project.tags.length && (
                                    <span><IconComponent icon={FaCircle} size={5} /></span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BoxProject
